import Header from "../App/components/Header/Index";
import { RouteBox } from "../styles/common/style";
import RouteMapping from "./routePath";

const RoutesList: React.FC = () => {
  return (
    <>
      <Header />
      <RouteBox>
        <RouteMapping />
      </RouteBox>
    </>
  );
};

export default RoutesList;